(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christus-video-hero"] && !Shopify.designMode) return;
  try {
    
  // Autoplay can be refused up front (Low Power Mode, data-saver) or interrupted
  // later (the browser pausing a backgrounded tab and not resuming it). Refusal
  // hides the video so the poster shows instead of a black rectangle;
  // interruption gets a bounded number of resume attempts, after which the
  // poster wins. There are no controls on this element, so a pause is never
  // something the visitor asked for.
  (function () {
    var stage = document.querySelector(".cr-vigil__stage");
    if (!stage) return;
    var video = stage.querySelector(".cr-vigil__video");
    if (!video) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.pause();
      video.removeAttribute("autoplay");
      return;
    }

    var resumes = 0;

    function fallToPoster() {
      video.style.display = "none";
    }

    function tryPlay() {
      var attempt = video.play();
      if (attempt && typeof attempt.catch === "function") {
        attempt.catch(fallToPoster);
      }
    }

    tryPlay();

    video.addEventListener("pause", function () {
      if (video.ended || document.hidden) return;
      if (resumes < 3) {
        resumes += 1;
        tryPlay();
      } else {
        fallToPoster();
      }
    });

    document.addEventListener("visibilitychange", function () {
      if (!document.hidden && video.paused && video.style.display !== "none") {
        resumes = 0;
        tryPlay();
      }
    });
  })();

  // Theme editor only: a re-rendered section is injected as markup, and inline
  // scripts in injected markup do not run — so the fold-fit above would be
  // lost until reload. Re-measure the chrome above the stage on section load.
  // Same arithmetic as the inline script; on the storefront this never fires.
  document.addEventListener("shopify:section:load", function (e) {
    var sec = e.target && e.target.querySelector && e.target.querySelector(".cr-vigil");
    if (!sec) return;
    var top = Math.round(sec.getBoundingClientRect().top + window.scrollY);
    sec.style.setProperty("--vigil-hdr", Math.max(0, top) + "px");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Sizes carry a real $2-4 upcharge at XL/2XL, so a price that never moves is
     a lie on two of five variants. This is the entire job of this script.
     The cart is not involved: the radios ARE name="id", so the correct variant
     posts whether or not any of this ever runs. */
  (function () {
    var root = document.querySelector('.pdp');
    if (!root) return;

    var scope = root.querySelector('[data-buy]');
    if (!scope) return;

    var now = root.querySelector('[data-price-now]');
    var was = root.querySelector('[data-price-was]');
    // Only rendered on a product whose sizes are priced differently — so on a
    // single-price product this is null and "From" can never appear.
    var from = root.querySelector('[data-price-from]');
    var min = root.getAttribute('data-price-min');

    scope.addEventListener('change', function (event) {
      var field = event.target;
      if (!field || field.name !== 'id') return;

      // Radios report themselves; a <select> reports through its chosen option.
      var source = field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
      if (!source) return;

      if (now && source.dataset.price) {
        now.textContent = source.dataset.price;
      }

      if (was) {
        var compare = source.dataset.compare || '';
        was.textContent = compare;
        was.hidden = compare === '';
      }

      // "From" is only honest while the number on screen is the lowest one.
      if (from) {
        from.hidden = source.dataset.priceRaw !== min;
      }
    });

    /* The picker's "Size guide" link. Without this it is a plain fragment
       jump to a closed disclosure; with it the disclosure opens first, the
       page scrolls so the disclosure's top lands a gutter below the viewport
       top (block:'start' + the scroll-margin on .pdp-facts), and focus lands
       on the summary so a keyboard user is where the content is.
       block:'nearest' was wrong here: it pinned the opened block's BOTTOM to
       the viewport's bottom pixel, so the last row of the chart sat on the
       screen edge — under the browser bar on a phone. */
    var guideLink = root.querySelector('[data-size-guide-link]');
    var guide = root.querySelector('[data-size-guide]');
    if (guideLink && guide) {
      guideLink.addEventListener('click', function (event) {
        event.preventDefault();
        guide.open = true;
        guide.scrollIntoView({ block: 'start' });
        var summary = guide.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
      });
    }

    /* The chart scroll containers: .has-more while there is chart to the
       right of the box, so the CSS can fade the inline end; off at the scroll
       end. Measured on scroll, on resize, and whenever a disclosure toggles —
       a closed <details> has no layout, so the first honest measure is the
       moment it opens. */
    var faders = Array.prototype.slice.call(root.querySelectorAll('[data-scroll-fade]'));
    function paintFade(el) {
      var more = el.scrollWidth - el.clientWidth - el.scrollLeft > 1;
      el.classList.toggle('has-more', more);
      el.classList.toggle('is-scrolled', el.scrollLeft > 0);
    }
    function paintAllFades() {
      faders.forEach(paintFade);
    }
    if (faders.length) {
      faders.forEach(function (el) {
        el.addEventListener('scroll', function () { paintFade(el); }, { passive: true });
      });
      Array.prototype.forEach.call(root.querySelectorAll('details'), function (d) {
        d.addEventListener('toggle', paintAllFades);
      });
      window.addEventListener('resize', paintAllFades);
      paintAllFades();
    }

    /* The sticky offsets, both columns. Each column pins at the gutter while
       it fits the viewport. A column taller than the viewport cannot pin at
       the top — its lower part is unreachable for as long as it holds (the
       gallery's second plate never seen; the buy box frozen with the facts
       stuck below the fold) — so its top offset is set to the viewport
       height minus its own height minus a gutter (negative when it
       overflows), which pins it with its BOTTOM a gutter above the
       viewport's bottom instead. Only ever lowers the offset: when a column
       fits, the CSS default (the gutter) stands. Re-measured on resize and
       whenever either column changes height — plates landing, a disclosure
       opening. Below the breakpoint both columns are static and this does
       nothing. */
    function pinColumn(col, prop) {
      col.style.removeProperty(prop);
      var cs = getComputedStyle(col);
      if (cs.position !== 'sticky') return;
      var gutter = parseFloat(cs.top) || 0;
      var slack = window.innerHeight - col.offsetHeight - gutter;
      if (slack < gutter) col.style.setProperty(prop, slack + 'px');
    }
    var columns = [
      [root.querySelector('.pdp-media'), '--pdp-media-top'],
      [root.querySelector('.pdp-info'), '--pdp-info-top']
    ].filter(function (pair) { return pair[0]; });
    function pinColumns() {
      columns.forEach(function (pair) { pinColumn(pair[0], pair[1]); });
    }
    if (columns.length) {
      pinColumns();
      window.addEventListener('resize', pinColumns);
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(pinColumns);
        columns.forEach(function (pair) { ro.observe(pair[0]); });
      }
    }

    /* The rail's ticks (phone only): the ink tick follows the plate in view.
       Progress along the rail's scroll range, not plate offsets — the last
       plate cannot reach the snap start (there is not enough rail left to
       scroll), so "at the end" is the honest signal for it. */
    var rail = root.querySelector('.pdp-gallery--multi');
    var ticks = rail ? root.querySelectorAll('[data-rail-ticks] .pdp-rail-tick') : [];
    function paintTicks() {
      var range = rail.scrollWidth - rail.clientWidth;
      var at = range > 0 ? Math.round(rail.scrollLeft / range * (ticks.length - 1)) : 0;
      Array.prototype.forEach.call(ticks, function (tick, i) {
        tick.classList.toggle('is-current', i === at);
      });
    }
    if (rail && ticks.length > 1) {
      rail.addEventListener('scroll', paintTicks, { passive: true });
      window.addEventListener('resize', paintTicks);
      paintTicks();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
